import { Card } from './Card'
import { config } from './config'
import { TitleProcess, Wrapper, TextWrapper, Cards } from './styles'
import { CardProp, ImageDescription } from './types'

interface ProcessProps {
  headerTitle: string
  cards: CardProp[]
  hexagonGrayFilled: ImageDescription
}

const { headerTitle, cards } = config as ProcessProps

export function ProjectExecution() {
  return (
    <Wrapper>
      <TextWrapper>
        <TitleProcess as="h3">{headerTitle}</TitleProcess>
      </TextWrapper>
      <Cards>
        {cards.map(card => (
          <Card key={card.id} {...card} />
        ))}
      </Cards>
    </Wrapper>
  )
}
